// src/components/payment/PaystackProvider.tsx
import React, { ReactNode } from "react";
import { useScript } from "../../hooks/useScript";
import { Loader2 } from "lucide-react";

interface PaystackProviderProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export const PaystackProvider: React.FC<PaystackProviderProps> = ({ children, fallback }) => {
  const { loaded, error } = useScript("https://js.paystack.co/v1/inline.js");

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <div className="text-center">
          <p className="text-red-400 mb-4">Failed to load payment system</p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 bg-primary text-white rounded-xl"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!loaded) {
    return fallback ? (
      <>{fallback}</>
    ) : (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <Loader2 className="w-12 h-12 animate-spin text-primary" />
      </div>
    );
  }

  return <>{children}</>;
};
